import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ITour from '../models/ITour';
// Tab "Termini" uklonjen iz prikaza – komponenta ostaje u ./Selector.tsx za eventualno vraćanje
// import Selector from './Selector';
import TourDetailsResponsive from './tour-details/TourDetailsTable';

interface DetailsProps {
    tour: ITour | null;
}

const Details: React.FC<DetailsProps> = ({ tour }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // const [detailsCategory, setDetailsCategory] = useState(1);

    const renderDetails = () => {
        if (tour === undefined || tour === null) {
            return null;
        }
        return <TourDetailsResponsive tourId={tour.id} />;
    };

    return (
        <Box
            sx={(theme) => ({
                ml: -1.5,
                mr: -1.5,
                p: 2,
                pt: 1,
                backgroundColor: "#ffffffff",
                borderRadius: 2,
                border: isMobile ? "none" : "1px solid #e3e4e9",
                ...theme.applyStyles("dark", {
                    backgroundColor: "#2c333dff",
                    border: isMobile ? "none" : "1px solid #454d58ff",
                })
            })}
        >
            {/* <Selector selectedValue={detailsCategory} onChange={setDetailsCategory} /> */}

            {renderDetails()}
        </Box>
    );
};

export default Details;
